import PropTypes from"prop-types";export const IconPropType=PropTypes.oneOfType([PropTypes.string,PropTypes.elementType,PropTypes.element]);